import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const EntityTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);

useEffect(() => {
if (showMasterShipper==true || showCustomBroker == true || showSecondNotify == true || showThirdNotify == true || showTransporter == true ||
showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showMasterShipper, showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo, showBookingParty, showSeller,
showImporter, showBuyer])

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className=" py-2">
                    <div className="row">
                    <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Shipper
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Consignee
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Customer
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Origin Agent
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                    
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Notify
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Consigned to Bank:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className>
                        <label htmlFor="" className="form-label">Add/Remove Entity:</label>
                        <div className="row">
                            <div className="col-md-2">
                            <input type="checkbox" className="mx-2" name="Master Shipper" id="Master Shipper" 
                            onChange={(e) => setShowMasterShipper(e.target.checked)} />

                                <label htmlFor="Master Shipper" className="form-label">Master Shipper</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Customs Broker" id="Customs Broker"
                                    onChange={(e)=> { setShowCustomBroker(e.target.checked) }} />
                                <label htmlFor="Customs Broker" className="form-label">Customs Broker</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Second Notify" id="Second Notify"
                                    onChange={(e)=> { setShowSecondNotify(e.target.checked) }} />
                                <label htmlFor="Second Notify" className="form-label">Second Notify</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Third Notify" id="Third Notify"
                                    onChange={(e)=> { setShowThirdNotify(e.target.checked) }} />
                                <label htmlFor="Third Notify" className="form-label">Third Notify</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Transporter" id="Transporter"
                                    onChange={(e)=> { setShowTransporter(e.target.checked) }} />
                                <label htmlFor="Transporter" className="form-label">Transporter</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Ship to" id="Ship to" onChange={(e)=> {
                                setShowShipTo(e.target.checked) }} />
                                <label htmlFor="Ship to" className="form-label">Ship to</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Booking Party" id="Booking Party"
                                    onChange={(e)=> { setShowBookingParty(e.target.checked) }} />
                                <label htmlFor="Booking Party" className="form-label">Booking Party</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Seller" id="Seller" onChange={(e)=> {
                                setShowSeller(e.target.checked) }} />
                                <label htmlFor="Seller" className="form-label">Seller</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Importer" id="Importer" onChange={(e)=> {
                                setShowImporter(e.target.checked) }} />
                                <label htmlFor="Importer" className="form-label">Importer</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Buyer" id="Buyer" onChange={(e)=> {
                                setShowBuyer(e.target.checked) }} />
                                <label htmlFor="Buyer" className="form-label">Buyer</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Certifiter" id="Certifiter"
                                    onChange={(e)=> { setShowCertifiter(e.target.checked) }} />
                                <label htmlFor="Certifiter" className="form-label">Certifiter</label>
                            </div>
                        </div>
                    </div>

                    {showExtraEntity && <div className="row">
                        {showMasterShipper &&   <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Master Shipper:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        }
                        {showCustomBroker && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                   Custom Broker:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>
                        }
                        {showSecondNotify && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Notify:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showThirdNotify && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Notify:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showTransporter && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                    Transporter:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showShipTo && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                   Ship to:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showBookingParty && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                   Party:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showSeller && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                   Seller:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showImporter && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                  Importer:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showBuyer && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                  Buyer:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                        {showCertifiter && <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red">
                                  Certifier:
                                </label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                    
                                </div>
                            </div>

                        </div>}
                    </div>}
                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default EntityTab